import React, { useState, useEffect, useCallback } from "react";
import { Button, Form, Card, Row, Col, Container, Spinner, Alert } from 'react-bootstrap';
import ReactQuill from 'react-quill';
import Select from 'react-select';
import 'react-quill/dist/quill.snow.css';
import { api } from '../../services/api.js';
import Swal from 'sweetalert2';
import Menu from '../../comum/Menu/menu.jsx';
import Footer from '../../comum/Footer/index.jsx';

function PortalFreelancer() {
    const [loading, setLoading] = useState(false);
    const [apresentacaoHTML, setApresentacaoHTML] = useState("");
    const [aceiteLGPD, setAceiteLGPD] = useState(false);
    const [dataAtualizacao, setDataAtualizacao] = useState(null);

    const [areasDisponiveis, setAreasDisponiveis] = useState([]);
    const [areasSelecionadas, setAreasSelecionadas] = useState([]);

    const [formData, setFormData] = useState({
        nome_candidato: "",
        email_candidato: "",
        telefone_candidato: "",
        endereco_completo: "",
        ja_trabalhou_floresta: "Não",
        loja_preferencia: ""
    });

    // --- CARREGAR ÁREAS DA API ---
    const carregarAreas = useCallback(async () => {
        try {
            const res = await api.get('/externo/areas');
            const options = (res.data || []).map(item => ({
                value: item.id_area || item.ID_AREA,
                label: item.descricao || item.DESCRICAO
            }));
            setAreasDisponiveis(options);
        } catch (err) {
            console.error("Erro ao carregar áreas:", err);
        }
    }, []);

    useEffect(() => {
        carregarAreas();
    }, [carregarAreas]);

    // --- FUNÇÃO PARA DESENCODER BASE64 DO BANCO ---
    const decodeBase64 = (str) => {
        try {
            if (!str) return "";
            return decodeURIComponent(escape(window.atob(str)));
        } catch (e) { return str; }
    };

    const encodeBase64 = (str) => {
        try {
            if (!str) return "";
            const bytes = new TextEncoder().encode(str);
            let binary = "";
            bytes.forEach(b => binary += String.fromCharCode(b));
            return window.btoa(binary);
        } catch (e) { return ""; }
    };

    const handleNomeChange = (e) => {
        setFormData({ ...formData, nome_candidato: e.target.value.toUpperCase() });
    };

    const handleEmailChange = (e) => {
        setFormData({ ...formData, email_candidato: e.target.value.toLowerCase() });
    };

    const handleTelefoneChange = (e) => {
        let value = e.target.value.replace(/\D/g, "");
        if (value.length <= 11) {
            value = value.replace(/^(\d{2})(\d)/g, "($1) $2");
            value = value.replace(/(\d)(\d{4})$/, "$1-$2");
            setFormData({ ...formData, telefone_candidato: value });
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const validarEmail = (email) => {
        return String(email).toLowerCase().match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/);
    };

    // --- AUTO-PREENCHIMENTO POR E-MAIL ---
    const checkEmailExistente = async (email) => {
        if (!email || !validarEmail(email)) return;

        try {
            const res = await api.get(`/externo/candidato/${email}`);
            const d = Array.isArray(res.data) ? res.data[0] : (res.data.dados || res.data);

            if (d && d.nome_candidato) {
                Swal.fire({
                    title: 'Cadastro localizado!',
                    html: `Olá <b>${d.nome_candidato}</b>, já temos o seu cadastro.<br>Deseja carregar seus dados para atualização?`,
                    icon: 'info',
                    showCancelButton: true,
                    confirmButtonText: 'Sim, carregar',
                    cancelButtonText: 'Não, limpar e-mail',
                    allowOutsideClick: false
                }).then((result) => {
                    if (result.isConfirmed) {
                        setFormData({
                            nome_candidato: (d.nome_candidato || "").toUpperCase(),
                            email_candidato: (d.email_candidato || "").toLowerCase(),
                            telefone_candidato: d.telefone_candidato || "",
                            endereco_completo: d.endereco_completo || "",
                            ja_trabalhou_floresta: d.ja_trabalhou_aqui === 'S' ? 'Sim' : 'Não',
                            loja_preferencia: d.loja_preferencia || ""
                        });

                        if (d.dta_alteracao) {
                            const [dataParte, horaParte] = d.dta_alteracao.split('T');
                            const [ano, mes, dia] = dataParte.split('-');
                            const horaFormatada = horaParte.substring(0, 8);
                            setDataAtualizacao(`${dia}/${mes}/${ano} ${horaFormatada}`);
                        }

                        if (d.texto_apresentacao) {
                            setApresentacaoHTML(decodeBase64(decodeBase64(d.texto_apresentacao)));
                        }

                        const idsString = d.areas_ids || d.AREAS_IDS;
                        if (idsString) {
                            const idsDoBanco = String(idsString).split(',').map(id => id.trim());
                            const selecionadas = areasDisponiveis.filter(opt =>
                                idsDoBanco.includes(String(opt.value))
                            );
                            setAreasSelecionadas(selecionadas);
                        }

                        setAceiteLGPD(d.lgpd_aceite === 'S');
                    } else {
                        setFormData(prev => ({ ...prev, email_candidato: "" }));
                        setDataAtualizacao(null);
                    }
                });
            }
        } catch (err) {
            console.error("Erro ao buscar cadastro:", err);
        }
    };

    const handleCancelar = () => {
        setFormData({
            nome_candidato: "",
            email_candidato: "",
            telefone_candidato: "",
            endereco_completo: "",
            ja_trabalhou_floresta: "Não",
            loja_preferencia: ""
        });
        setApresentacaoHTML("");
        setAreasSelecionadas([]);
        setAceiteLGPD(false);
        setDataAtualizacao(null);
        carregarAreas();
        Swal.fire("Cancelado", "O formulário foi limpo.", "info");
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validarEmail(formData.email_candidato)) return Swal.fire("E-mail Inválido", "Insira um e-mail válido.", "warning");
        if (!aceiteLGPD) return Swal.fire("Atenção", "Aceite os termos da LGPD.", "warning");
        if (areasSelecionadas.length === 0) return Swal.fire("Atenção", "Selecione ao menos uma área de interesse.", "warning");
        if (!apresentacaoHTML.trim()) return Swal.fire("Atenção", "Preencha o resumo da sua experiência profissional.", "warning");

        setLoading(true);

        const payload = {
            nome_candidato: formData.nome_candidato,
            email_candidato: formData.email_candidato,
            telefone_candidato: formData.telefone_candidato,
            endereco_completo: formData.endereco_completo,
            ja_trabalhou_aqui: formData.ja_trabalhou_floresta === 'Sim' ? 'S' : 'N',
            loja_preferencia: formData.loja_preferencia,
            texto_apresentacao: encodeBase64(apresentacaoHTML),
            nome_arquivo: "FREELANCER",
            curriculo_base64: "",
            areas: areasSelecionadas.map(a => a.value)
        };

        try {
            await api.post('/externo/candidatar', payload);
            await Swal.fire("Sucesso!", "Cadastro de Freelancer gravado com sucesso.", "success");
            window.location.reload();
        } catch (err) {
            Swal.fire("Erro", "Falha ao enviar cadastro de Freelancer.", "error");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="d-flex flex-column" style={{ minHeight: '100vh', backgroundColor: '#f4f7f6' }}>
            <Menu modulo="RH" />
            <Container className="py-5 mt-5">
                <Card className="border-0 shadow-sm">
                    <Card.Header className="bg-success text-white text-center">
                        <h5 className="mb-0">Portal de Vagas Temporárias - Cadastro de Freelancer</h5>
                    </Card.Header>
                    <Card.Body className="p-4">
                        <Form onSubmit={handleSubmit}>

                            <h6 className="fw-bold text-success border-bottom pb-2 mb-3">DADOS PESSOAIS & CONTATO</h6>

                            {dataAtualizacao && (
                                <Row className="mb-3">
                                    <Col md={4}>
                                        <Form.Label className="small fw-bold text-muted">ÚLTIMA ATUALIZAÇÃO DO CADASTRO</Form.Label>
                                        <Form.Control
                                            type="text"
                                            value={dataAtualizacao}
                                            disabled
                                            className="bg-light border-0 text-success fw-bold"
                                        />
                                    </Col>
                                </Row>
                            )}

                            <Row className="mb-3">
                                <Col md={6}>
                                    <Form.Label className="small fw-bold">E-MAIL</Form.Label>
                                    <Form.Control
                                        required
                                        type="email"
                                        name="email_candidato"
                                        value={formData.email_candidato}
                                        onBlur={e => checkEmailExistente(e.target.value)}
                                        onChange={handleEmailChange}
                                        placeholder="Seu e-mail de contato"
                                    />
                                </Col>
                                <Col md={6}>
                                    <Form.Label className="small fw-bold">NOME COMPLETO</Form.Label>
                                    <Form.Control required placeholder="NOME COMPLETO EM MAIÚSCULO" name="nome_candidato" value={formData.nome_candidato} onChange={handleNomeChange} />
                                </Col>
                            </Row>

                            <Row className="mb-3">
                                <Col md={4}>
                                    <Form.Label className="small fw-bold">TELEFONE / WHATSAPP</Form.Label>
                                    <Form.Control required value={formData.telefone_candidato} onChange={handleTelefoneChange} placeholder="(00) 00000-0000" />
                                </Col>
                                <Col md={4}>
                                    <Form.Label className="small fw-bold">JÁ TRABALHOU NA EMPRESA?</Form.Label>
                                    <Form.Select required name="ja_trabalhou_floresta" value={formData.ja_trabalhou_floresta} onChange={handleInputChange}>
                                        <option value="Não">Não</option>
                                        <option value="Sim">Sim</option>
                                    </Form.Select>
                                </Col>
                                <Col md={4}>
                                    <Form.Label className="small fw-bold">LOJA DE PREFERÊNCIA</Form.Label>
                                    <Form.Select required name="loja_preferencia" value={formData.loja_preferencia} onChange={handleInputChange}>
                                        <option value="">Selecione a unidade...</option>
                                        <option value="Loja Volta Redonda - Amaral Peixoto">Volta Redonda - Amaral Peixoto</option>
                                        <option value="Loja Volta Redonda - São Lucas">Volta Redonda - São Lucas</option>
                                        <option value="Loja Volta Redonda - Aterrado">Volta Redonda - Aterrado</option>
                                        <option value="Loja Volta Redonda - Retiro">Volta Redonda - Retiro</option>
                                        <option value="Loja Volta Redonda - Vila">Volta Redonda - Vila Santa Cecília</option>
                                        <option value="Loja Barra Mansa">Barra Mansa</option>
                                        <option value="Loja Resende">Resende</option>
                                        <option value="Loja Valença">Valença</option>
                                        <option value="Loja Pinheiral">Pinheiral</option>
                                        <option value="CDP Barra Mansa">Barra Mansa - Dutra</option>
                                        <option value="CD Volta Redonda">Volta Redonda - Três Poços</option>
                                    </Form.Select>
                                </Col>
                            </Row>

                            <Form.Group className="mb-4">
                                <Form.Label className="small fw-bold">ENDEREÇO COMPLETO</Form.Label>
                                <Form.Control required name="endereco_completo" value={formData.endereco_completo} onChange={handleInputChange} placeholder="Rua, número, bairro, cidade..." />
                            </Form.Group>

                            <h6 className="fw-bold text-success border-bottom pb-2 mb-3 mt-4">VAGA E ÁREAS DE INTERESSE</h6>
                            <Row className="mb-4">
                                <Col md={12}>
                                    <Form.Label className="small fw-bold">ÁREAS DE INTERESSE (CARGOS)</Form.Label>
                                    <Select
                                        isMulti
                                        options={areasDisponiveis}
                                        placeholder="Selecione as áreas..."
                                        value={areasSelecionadas}
                                        onChange={setAreasSelecionadas}
                                        className="basic-multi-select"
                                        classNamePrefix="select"
                                    />
                                </Col>
                            </Row>

                            <h6 className="fw-bold text-success border-bottom pb-2 mb-3 mt-4">EXPERIÊNCIA PROFISSIONAL / APRESENTAÇÃO</h6>
                            <Form.Group className="mb-4">
                                <Form.Label className="small fw-bold">DESCREVA SUA EXPERIÊNCIA E ATIVIDADES QUE JÁ DESEMPENHOU</Form.Label>
                                <ReactQuill
                                    theme="snow"
                                    value={apresentacaoHTML}
                                    onChange={setApresentacaoHTML}
                                    style={{ height: '180px', marginBottom: '60px' }}
                                />
                            </Form.Group>

                            <Alert variant="light" className="border small">
                                <h6><b>TERMOS E PRIVACIDADE (LGPD)</b></h6>
                                <Form.Check
                                    type="checkbox"
                                    label="Aceito o tratamento dos meus dados para convocação em vagas temporárias (Freelancer)."
                                    required
                                    checked={aceiteLGPD}
                                    onChange={e => setAceiteLGPD(e.target.checked)}
                                />
                            </Alert>

                            <div className="d-flex gap-3 mt-4">
                                <Button
                                    variant="outline-secondary"
                                    size="lg"
                                    type="button"
                                    className="w-50 fw-bold"
                                    onClick={handleCancelar}
                                    disabled={loading}
                                >
                                    CANCELAR / LIMPAR
                                </Button>

                                <Button
                                    variant="success"
                                    size="lg"
                                    type="submit"
                                    className="w-50 fw-bold"
                                    disabled={loading}
                                >
                                    {loading ? <Spinner size="sm" animation="border" /> : "GRAVAR CADASTRO FREELANCER"}
                                </Button>
                            </div>
                        </Form>
                    </Card.Body>
                </Card>
            </Container>
            <Footer />
        </div>
    );
}

export default PortalFreelancer;